(function () {
  var MIN_MS = 2500;
  var loadedAt = Date.now();

  function honeypotTripped(form) {
    var hp = form.querySelector('.drp-honeypot');
    return hp && hp.value.trim().length > 0;
  }

  function tooFast() {
    return Date.now() - loadedAt < MIN_MS;
  }

  function guardMessage(form, text) {
    var target =
      form.querySelector('.drp-spam-guard-msg') ||
      form.querySelector('.drp-optin__message--error') ||
      form.querySelector('.drp-contact-form__message--error');
    if (target) {
      target.textContent = text;
      target.hidden = false;
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('form[data-drp-spam-guard]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        if (honeypotTripped(form)) {
          event.preventDefault();
          return;
        }

        if (tooFast()) {
          event.preventDefault();
          guardMessage(form, 'Please wait a moment and try again.');
        }
      });
    });
  });
})();
